export default "__VITE_ASSET__dQ6RfEXg__$_?react__"